import { Button } from '@fullscreendigital/carrefour-dex-fe'
import { Box, Grid } from '@mui/material'
import { Modal } from 'components/core-ui/Modal'
import dayjs from 'dayjs'

const WasteManagementNoDailyReportsModal = props => {
  const { isModalOpen, closeModal, info } = props

  const save = () => {
    localStorage.setItem('wasteManagementNoDailyReportsModalVisible', dayjs().format('YYYY-MM-DD'))
    closeModal()
  }

  return (
    <Modal isModalOpen={isModalOpen} modalTitle="Atentionare rapoarte zilnice" closeModal={save} modalWidth="50%">
      <Grid container spacing={4}>
        <Grid xs={12} item>
          {info.map(item => (
            <Box key={item.category} style={{marginTop: '24px'}}>{item.message}</Box>
          ))}
        </Grid>
        <Grid xs={6} item />
        <Grid xs={6} item style={{ textAlign: 'right' }}>
          <Button variant="contained" label="Ok" onClick={save} />
        </Grid>
      </Grid>
    </Modal>
  )
}

export default WasteManagementNoDailyReportsModal
